<template>
  <div class="wsqmid-wrapper">
    <div class="wsqmid box_v">
      <div class="mid-title" style="width: 29.06%;" :style="{fontSize:height>1000?'30px':'24px'}">
        小区负责人
      </div>

      <div class="box people-wrapper">
        <div class="box_v mid-people box_f1" v-for="(item,index) in leader" :key="index">
          <div class="mid-pic" :style="{height: height*0.098+'px',width:height*0.098+'px',marginBottom:height*0.025+'px'}">
            <img :src="item.headPicUrl":style="{height: height*0.098+'px',width:height*0.098+'px'}" >
          </div>
          <div class="mid-name">{{item.realName}}</div>
          <div class="mid-job">{{item.proTitle}}</div>
        </div>
      </div>
      <div class="wsq-active box">
        <div class="box box_f1 active-wrapper" style="margin-right:2.325%">
          <div class="active-title mid-title" :style="{fontSize:height>1000?'30px':'24px'}">
            事件办理
          </div>
          <div class="box_v box_f1 active-item">
            <div><span style="font-size: 30px">{{weibanliNumber}}</span>个</div>
            <div>未办理数</div>
          </div>
          <div class="box_v box_f1 active-item">
            <div><span style="font-size: 30px">{{yuqiNumber}}</span>个</div>
            <div>逾期办理数</div>
          </div>
        </div>

        <div class="box box_f1 active-wrapper" style="margin-left:2.325%">
          <div class="active-title mid-title" :style="{fontSize:height>1000?'30px':'24px'}">
            社区活动
          </div>
          <div class="box_v box_f1 active-item">
            <div><span style="font-size: 30px">{{huodongNumber}}</span>个</div>
            <div>活动数</div>
          </div>
          <div class="box_v box_f1 active-item">
            <div><span style="font-size: 30px">{{qiandaoNumber}}</span>个</div>
            <div>签到人数</div>
          </div>
        </div>

      </div>
    </div>


  </div>
</template>

<script>
  import xScroll from '../../../components/xScroll'
  export default {
    components: {
      xScroll
    },
    data () {
      return {
      }
    },
    props:{
      width:Number,
      height:Number,
      manager:{
        type:Object,
        default:{}
      },
      leader:{
        type:Array,
        default:[]
      },
      yuqiNumber:{
        type:Number,
        default:0
      },
      weibanliNumber:{
        type:Number,
        default:0
      },
      huodongNumber:{
        type:Number,
        default:0
      },
      qiandaoNumber:{
        type:Number,
        default:0
      }
    },
    computed: {
      active () {//60px
        return this.height*0.055+'px'
      },
      a () {//30px
        return this.height*0.029
      },
      b () {//20px
        return this.height*0.0196+'px'
      },
      picWidth () {
        if (this.height > 1000) {
          return this.height*0.16
        }else {
          return this.height*0.19
        }

      },
      picHeight () {
        if (this.height > 1000) {
          return this.height * 0.185
        }else {
          return this.height * 0.21
        }
      }
    }
  }
</script>

<style scoped>
  .wsqmid-wrapper{
    height: 82.75%;
  }
  .wsqmid{
    /*background: #ddd;*/
    height: 100%;
    position: relative;
    justify-content: space-between;
  }
  .mid-title{
    color: #fff;
    position: absolute;
    top:-5.5%;
    left:50%;
    transform: translateX(-50%);
    height:8.33%;
    background: #ff6344;
    border-radius: 25px;
    box-shadow: inset 0px 0px 10px 3px #fa513a;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .people-wrapper{
    border: 3px solid #fff;
    padding: 8.139% 0 5.813%
  }
  .mid-people{
    align-items: center;

  }

  .mid-pic img {
    border-radius: 50%;
  }
  .mid-name{
    font-size:25px;
    color:#444;
    text-align: center;
    font-weight: 600;
  }
  .mid-job{
    font-size:18px;
    color:#666;
    text-align: center;
  }
  .wsq-active{
    color:#ff7900;
    height:43.05%
  }
  .active-wrapper{
    background-color: rgba(255,255,255,0.5);
    border:3px solid #fff;
    position: relative;
    font-size: 24px;
  }
  .active-title{
    height:19.35%;
    top:-12.9%;
    width: 60.97%;
  }
  .active-item{
    padding-top:20%;
    text-align: center;
  }

</style>
